import React from "react";
import { motion } from "framer-motion";

// Masked line-by-line reveal — CSS-driven so it can never get stuck hidden
export const MaskReveal = ({ lines = [], className = "", delay = 0, lineClass = "" }) => (
  <span className={`block ${className}`}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <span className={`reveal-up ${lineClass}`} style={{ animationDelay: `${delay + i * 0.12}s` }}>
          {line}
        </span>
      </span>
    ))}
  </span>
);

// Scroll-triggered fade-up wrapper
export const FadeUp = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Staggered container
export const Stagger = ({ children, className = "", stagger = 0.1 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ show: { transition: { staggerChildren: stagger } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 26 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.16, 1, 0.3, 1] } },
    }}
  >
    {children}
  </motion.div>
);
